import { msg } from "../locales/translate.ts";
import { GD } from "src/GD";
import { parseLivenessResponse, type TLivenessServiceName } from "./livenessData";
import { formatLivenessDate, livenessFilter, parseLivenessAggregate, type LivenessBucket } from "./livenessAggregated";

export async function loadLiveness(signal: AbortSignal, hours = 24) {
	const response = await GD.REQ_API.request({
		method: "liveness/aggregated", httpMethod: "POST", data: { filter: livenessFilter(hours) },
		headers: { ignoreBusy: "true" }, signal,
	});
	if (response.error) throw new Error(response.error.message || msg("couldNotLoadServiceStatus"));
	return parseLivenessAggregate(response.data);
}

export async function loadLivenessDetails(signal: AbortSignal, service: TLivenessServiceName, bucket: LivenessBucket) {
	const response = await GD.REQ_API.request({
		method: "liveness/list", httpMethod: "POST",
		data: { filter: { service, from_date: formatLivenessDate(bucket.from), to_date: formatLivenessDate(bucket.to) } },
		headers: { ignoreBusy: "true" }, signal,
	});
	if (response.error) throw new Error(response.error.message || msg("couldNotLoadIntervalDetails_a8f1dbc0"));
	return parseLivenessResponse(response.data);
}
